export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11245.71f7dff9.jpg";